import React from "react";
export default class MidStudentMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          time: ''
        };
      }
    
    
    
      FNastya() {
        var d = new Date();
        var nn = d.getDay() - 1;
        if (document.getElementById(nn + 'Menu')) {
        document.getElementById(nn + "table").style.display = "block";
        document.getElementById(nn + 'Menu').style.backgroundColor="#FF7A00";
        document.getElementById(nn + "div").style.display = "block";
        document.getElementById(nn + 'Menu').style.color="yellow";
      }}
      
    
      componentDidUpdate() {
        this.FNastya()
      }
    
    
      ClickDay(i) {
        let t = document.getElementById(i + "table");
        let d = document.getElementById(i + "div");
      
        for (let n = 0; n < document.getElementsByClassName("tNastya").length; n++) {
          document.getElementsByClassName("tNastya")[n].style.display = "none";
          document.getElementsByClassName("dNastya")[n].style.display = "none";
          document.getElementById(n + 'Menu').style.backgroundColor="#2F80ED";
          t.style.display = "block";
          d.style.display = "block";
          document.getElementById(i + 'Menu').style.backgroundColor="#FF7A00";
        }
      }
    
      render() {
        const timeconst = this.state.time;
        const groupByKey = (list, key, { omitKey = false }) => list.reduce((hash, { [key]: value, ...rest }) => ({ ...hash, [value]: (hash[value] || []).concat(omitKey ? { ...rest } : { [key]: value, ...rest }) }), {})
        let t = [];
    
        let DN = groupByKey(this.props.arrA, 'Day_name', { omitKey: true });
        let FullweekDayName= groupByKey(this.props.arrA, 'Day_name', { omitKey: true });
    
        let DNK = Object.entries(DN);
        let FWD = Object.entries(FullweekDayName)
        
        let TA = [];
        let MA = [];
    
    
        for (let i = 0; i < FWD.length; i++) {
          let TAa = [];
    
          TA.push(
            <div key={i + 'DNK'} id={i + 'div'} className='dNastya'>{FWD[i][0]}</div>
            
          )
          MA.push(
            <button className="menu" onClick={() => this.ClickDay(i)} key={i + 'Menu'} id={i + 'Menu'}>{DNK[i][0]}</button>
          )
    
          for (let j = 0; j < DNK[i][1].length; j++) {
            console.log(DNK[i][1][j].StudyTypeName)
            if (DNK[i][1][j].discipline) {
            TAa.push(
              <div>  
              <div key={i + ' ' + j}></div>
               {/* <td>{DNK[i][1][j].Groups}</td>
                <td>{DNK[i][1][j].StudyTypeName}</td>
                <td>{DNK[i][1][j].Time_}</td>
                <td>{DNK[i][1][j].discipline}</td>
                <td>{DNK[i][1][j].nedely}</td>*/}
    
               <div className="page__mobile"> 
                  <div className="page block__time">
                    <div className="page block__left">
                 <div className="time">{DNK[i][1][j].Time_}<br/>
                 <p className="EveryWeek">{DNK[i][1][j].EveryWeek}</p>
                 </div>
                 <div> 
                   <span className="StudyTypeName"> {DNK[i][1][j].StudyTypeName}
                   </span>
                </div>
                </div>
                </div>
                <div className="page block__discipline">
              
                              <div className="discipline">
                              <svg width="12" height="16" viewBox="0 0 12 16" 
                              fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.6 4.75994V13.0407C11.6 13.4583 11.2384 13.6575 10.8 13.9687C10.448 14.2191 9.99999 13.9087 9.99999 13.4991V5.40794C9.99999 5.23914 9.94079 5.07834 9.74879 4.97994C9.55679 4.88154 3.55839 1.72794 3.55839 1.72794C3.46159 1.69194 3.03919 1.42554 2.47599 1.71514C1.94079 1.99034 1.64959 2.28954 1.57519 2.43034L8.11919 6.01594C8.29279 6.10714 8.39999 6.24794 8.39999 6.42874V15.0703C8.39801 15.1678 8.36947 15.2629 8.31745 15.3454C8.26543 15.4278 8.19191 15.4946 8.10479 15.5383C8.02196 15.5792 7.93076 15.6003 7.83839 15.5999C7.72975 15.6012 7.62288 15.5724 7.52959 15.5167C7.35759 15.4119 1.31039 11.7039 0.911192 11.4631C0.719192 11.3479 0.494392 11.1119 0.489593 10.9367L0.399993 2.70794C0.399993 2.54954 0.381593 2.27034 0.631193 1.88234C1.18879 1.01514 3.13439 0.0287419 4.11919 0.539942L11.3184 4.18394C11.492 4.27354 11.6 4.45274 11.6 4.75994Z" fill="#FF7A00"/>
                              </svg>
                              {DNK[i][1][j].discipline}
                              </div>
    <div className="AuditoryName__Groups"> 
                              <div className="AuditoryName">
                              <svg width="15" height="16" viewBox="0 0 15 16" 
                              fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.5186 14.0765L13.499 11H12.3802L13.0015 14H2.06239L2.68371 11H1.56489L0.54452 14.0765C0.285699 14.8595 0.744416 15.5 1.56489 15.5H13.499C14.3195 15.5 14.7782 14.8595 14.5186 14.0765ZM11.2614 4.25C11.2614 3.25544 10.8684 2.30161 10.169 1.59835C9.46963 0.895088 8.52104 0.5 7.53194 0.5C6.54284 0.5 5.59425 0.895088 4.89485 1.59835C4.19545 2.30161 3.80253 3.25544 3.80253 4.25C3.80253 7.83125 7.53194 11.75 7.53194 11.75C7.53194 11.75 11.2614 7.83125 11.2614 4.25ZM5.51806 4.295C5.51806 3.17675 6.41909 2.27075 7.53194 2.27075C8.06596 2.27075 8.5781 2.48406 8.95571 2.86375C9.33331 3.24344 9.54545 3.75841 9.54545 4.29538C9.54545 4.83234 9.33331 5.34731 8.95571 5.727C8.5781 6.10669 8.06596 6.32 7.53194 6.32C6.99783 6.32 6.48559 6.10665 6.10791 5.72689C5.73024 5.34713 5.51806 4.83206 5.51806 4.295Z" fill="#FF7A00"/>
                              </svg>
                              {DNK[i][1][j].AuditoryName}</div>
    
                              <div className="Groups">
                              <svg width="15" height="15" viewBox="0 0 15 15" 
                              fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.30442 6.79163C8.23857 6.79163 9.13446 7.16477 9.79501 7.82896C10.4556 8.49315 10.8266 9.39398 10.8266 10.3333V14.5833H9.41775V10.3333C9.41778 9.79127 9.21183 9.26972 8.84202 8.87536C8.47222 8.481 7.96652 8.24363 7.4284 8.21183L7.30442 8.20829C6.76537 8.20826 6.24669 8.41536 5.85449 8.7872C5.46229 9.15905 5.22623 9.66754 5.19461 10.2086L5.19109 10.3333V14.5833H3.7822V10.3333C3.7822 9.39398 4.15329 8.49315 4.81383 7.82896C5.47438 7.16477 6.37027 6.79163 7.30442 6.79163ZM2.72553 8.91663C2.92207 8.91663 3.11298 8.94 3.29613 8.98321C3.17569 9.34375 3.10436 9.71904 3.0841 10.0988L3.07776 10.3333V10.3942C2.99678 10.3651 2.91256 10.346 2.82697 10.3375L2.72553 10.3333C2.46286 10.3333 2.20961 10.4317 2.01516 10.6093C1.82071 10.7869 1.69902 11.0309 1.6738 11.2938L1.66887 11.3958V14.5833H0.259979V11.3958C0.259979 10.7383 0.519742 10.1077 0.982123 9.64276C1.4445 9.17782 2.07163 8.91663 2.72553 8.91663ZM11.8833 8.91663C12.5372 8.91663 13.1643 9.17782 13.6267 9.64276C14.0891 10.1077 14.3489 10.7383 14.3489 11.3958V14.5833H12.94V11.3958C12.94 11.1317 12.8421 10.877 12.6655 10.6815C12.4889 10.486 12.2462 10.3636 11.9847 10.3383L11.8833 10.3333C11.76 10.3333 11.6417 10.3545 11.5311 10.3935V10.3333C11.5311 9.86154 11.455 9.40821 11.3134 8.98463C11.5 8.93921 11.6913 8.91638 11.8833 8.91663ZM2.72553 4.66663C3.19261 4.66663 3.64055 4.8532 3.97083 5.18529C4.3011 5.51739 4.48664 5.96781 4.48664 6.43746C4.48664 6.90711 4.3011 7.35753 3.97083 7.68963C3.64055 8.02172 3.19261 8.20829 2.72553 8.20829C2.25846 8.20829 1.81051 8.02172 1.48024 7.68963C1.14997 7.35753 0.964423 6.90711 0.964423 6.43746C0.964423 5.96781 1.14997 5.51739 1.48024 5.18529C1.81051 4.8532 2.25846 4.66663 2.72553 4.66663ZM11.8833 4.66663C12.3504 4.66663 12.7983 4.8532 13.1286 5.18529C13.4589 5.51739 13.6444 5.96781 13.6444 6.43746C13.6444 6.90711 13.4589 7.35753 13.1286 7.68963C12.7983 8.02172 12.3504 8.20829 11.8833 8.20829C11.4162 8.20829 10.9683 8.02172 10.638 7.68963C10.3077 7.35753 10.1222 6.90711 10.1222 6.43746C10.1222 5.96781 10.3077 5.51739 10.638 5.18529C10.9683 4.8532 11.4162 4.66663 11.8833 4.66663ZM2.72553 6.08329C2.63212 6.08329 2.54253 6.12061 2.47648 6.18703C2.41042 6.25344 2.37331 6.34353 2.37331 6.43746C2.37331 6.53139 2.41042 6.62147 2.47648 6.68789C2.54253 6.75431 2.63212 6.79163 2.72553 6.79163C2.81895 6.79163 2.90854 6.75431 2.97459 6.68789C3.04065 6.62147 3.07776 6.53139 3.07776 6.43746C3.07776 6.34353 3.04065 6.25344 2.97459 6.18703C2.90854 6.12061 2.81895 6.08329 2.72553 6.08329ZM11.8833 6.08329C11.7899 6.08329 11.7003 6.12061 11.6342 6.18703C11.5682 6.25344 11.5311 6.34353 11.5311 6.43746C11.5311 6.53139 11.5682 6.62147 11.6342 6.68789C11.7003 6.75431 11.7899 6.79163 11.8833 6.79163C11.9767 6.79163 12.0663 6.75431 12.1324 6.68789C12.1984 6.62147 12.2355 6.53139 12.2355 6.43746C12.2355 6.34353 12.1984 6.25344 12.1324 6.18703C12.0663 6.12061 11.9767 6.08329 11.8833 6.08329ZM7.30442 0.416626C8.05174 0.416626 8.76845 0.715137 9.29689 1.24649C9.82533 1.77784 10.1222 2.49851 10.1222 3.24996C10.1222 4.00141 9.82533 4.72208 9.29689 5.25343C8.76845 5.78478 8.05174 6.08329 7.30442 6.08329C6.5571 6.08329 5.84039 5.78478 5.31195 5.25343C4.78352 4.72208 4.48664 4.00141 4.48664 3.24996C4.48664 2.49851 4.78352 1.77784 5.31195 1.24649C5.84039 0.715137 6.5571 0.416626 7.30442 0.416626ZM7.30442 1.83329C6.93076 1.83329 6.5724 1.98255 6.30819 2.24822C6.04397 2.5139 5.89553 2.87424 5.89553 3.24996C5.89553 3.62568 6.04397 3.98602 6.30819 4.25169C6.5724 4.51737 6.93076 4.66663 7.30442 4.66663C7.67808 4.66663 8.03644 4.51737 8.30066 4.25169C8.56487 3.98602 8.71331 3.62568 8.71331 3.24996C8.71331 2.87424 8.56487 2.5139 8.30066 2.24822C8.03644 1.98255 7.67808 1.83329 7.30442 1.83329Z" fill="#FF7A00"/>
                              </svg>
       {DNK[i][1][j].Groups}</div>
       </div>
                </div>
               </div>
              </div>
            )
          }
        }
        if (TAa.length > 0) {
          TA.push(
            <div key={i + 'table'} id={i + 'table'} className="tNastya">
             {TAa}
          </div>
          )
        } else {
          TA.push(
            <div key={i + 'table'} id={i + 'table'} className="tNastya">
             <h1 className="noSheduller"> Расписание отсутствует</h1> 
            </div>
  
          )
        }
  
      }
    
        return (
          <div className="wrapper__mobile">
            <div className="mobile__grid" >
              {MA}
            </div>
            <div className="table__mobile">
              {TA}
            </div>
          </div>
        )
    
      }
    
    }